var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trix-widget"},[_c('div',{staticClass:"bg-white rounded",style:(_vm.getStyles)},[(!_vm.editMode)?_c('div',{style:(_vm.getStyles),domProps:{"innerHTML":_vm._s(_vm.fetchData)}}):_c('html-editor',{attrs:{"editMode":_vm.editMode,"value":_vm.fetchData},on:{"on-update":_vm.onUpdate}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }